export default __webpack_public_path__ + "./images/uy.d7e70d22.png";